export default __webpack_public_path__ + "static/media/tesla.a7f4d496.png";